import React, {memo} from 'react'
import cx from 'classnames'

/* Components */
import DeliveryOptionsFull from './components/full/DeliveryOptionsFull'
import DeliveryOptionsSkeleton from './DeliveryOptionsSkeleton'

/* Styles */
import s from './delivery-options.scss'

const DeliveryOptions = memo(({
  dispatch,
  className,
  componentData,
  sku,
  merchantName,
  merchantId,
  listingId,
  price,
  dueDate,
  deliveryTooltips,
  fragmentsMap,
  location,
  categories,
  product,
  categoryId,
  categoryName
}) => {
  const buyBoxWinnerDueDate = dueDate?.find((item) => item?.isBuyBoxWinner)
  const hasFasterMerchant = dueDate?.find((item) => item?.isFasterMerchant)

  if (dueDate?.length === 0) {
    return (
      <div className={cx(s.root, s.withoutPadding, className)}>
        <DeliveryOptionsSkeleton />
      </div>
    )
  }

  return (
    <div
      className={cx(s.root, s[componentData?.displayType], className)} data-test-id={'delivery-options'}>
      {
        <DeliveryOptionsFull
          dispatch={dispatch}
          isDisabledTitle={false}
          fragmentsMap={fragmentsMap}
          deliveryTooltips={deliveryTooltips}
          sku={sku}
          hasFasterMerchant={hasFasterMerchant}
          merchantName={merchantName}
          merchantId={merchantId}
          categoryId={categoryId}
          categoryName={categoryName}
          price={price}
          listingId={listingId}
          buyBoxWinnerDueDate={buyBoxWinnerDueDate}
          location={location}
          categories={categories}
          productModel={product} />
      }
    </div>
  )
})

export default DeliveryOptions
